import { z } from "zod";

export const timeEntrySchema = z.object({
  date: z
    .date({ message: "Date is required" })
    .refine(
      (d) => {
        const today = new Date();
        today.setHours(23, 59, 59, 999);
        return d <= today;
      },
      { message: "Date cannot be in the future" },
    ),
  matter_id: z.string().min(1, "Matter is required"),
  matter: z.string().min(1, "Matter is required"),
  task: z.string(),
  activity: z.string(),
  duration: z.number().positive("Duration must be greater than 0"),
  description: z
    .string()
    .min(1, "Narrative is required")
    .refine((s) => s !== "Please fill in the narrative.", {
      message: "Please write a real narrative",
    }),
});

export type TimeEntryFormValues = z.infer<typeof timeEntrySchema>;

export const defaultFormValues: TimeEntryFormValues = {
  date: new Date(),
  matter_id: "",
  matter: "",
  task: "",
  activity: "",
  duration: 0,
  description: "",
};
